var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd00",
    d: "M7.5 0.25 L9.375 6 h5.625 L10.375 9.25 L12.25 14.875 L7.5 11.375 L2.75 14.875 L4.625 9.25 L0 6 h5.625 Z"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSI+DQogICAgPHBhdGggZmlsbD0iI2ZmYmQwMCIgZD0iTTcuNSAwLjI1IEw5LjM3NSA2IGg1LjYyNSBMMTAuMzc1IDkuMjUgTDEyLjI1IDE0Ljg3NSBMNy41IDExLjM3NSBMMi43NSAxNC44NzUgTDQuNjI1IDkuMjUgTDAgNiBoNS42MjUgWiIgLz4NCjwvc3ZnPg0K";
export { SvgStar as ReactComponent };